import React, { useContext } from 'react';
import '../../ui-styles/bottomSlider/BottomDeleteSlide.css';
import { LangCtx } from "../context";

const ConfirmCancellation = (props) => {
    const { l } = useContext(LangCtx);


    return <div className={props.slideD ? "btmEDSlider slideUp" : "btmEDSlider"}>
        <div className="btmEDCntnr">
            <div className="btmSliderGroup">
              
                    {props?.paymentMode && props?.paymentMode === 'prePaid' && 
                        <div className="ConfirmationTxt">
                        <span className="alertTxt">{l.cancel_txt}<br/>{l.cancel_txt2}</span>
                    </div>
                    }
                {props?.paymentMode && props?.paymentMode === 'prePaid' ? 
                     <div className="txtCenter pdngMD">
                     <span className="redTxt">{l.nonrefund_cancel_note_txt}</span>
                 </div> : 

                    <div className="ConfirmationTxt">
                    <span className="alertTxt">{l.cancel_appointment}</span>
                    </div>
            }  
                <div className="btnSlideItem" onClick={props.handleConfirm}>
                    <span className="btmTxtDft">{props?.paymentMode === 'prePaid' ? l.yes_btn : l.yes_cancel_btn}</span>
                </div>
            </div>
            <div className="btmSliderClose" onClick={props.handleCancel}>
                <span className="btmTxtDanger">{l.no_btn}</span>
            </div>
        </div>
    </div>

}

export default ConfirmCancellation;
